import React from "react";
import { Link } from "react-router-dom";

export default function ContactMenu(props) {
  return (
    <div className="flex justify-around flex-wrap gap-[20px] md:gap-[0px]">
      <Link to={`/${props.lang}/about-us`}>
        <h1 className="text-[22px] md:text-[28px] xl:text-[32px] px-[25px] cursor-pointer">
          {props.lang === "th" ? "เกี่ยวกับเรา" : "About Us"}
        </h1>
        {props.isOpen === 1 && (
          <hr className="rounded-[10px] h-[9px] w-full bg-lightGray" />
        )}
      </Link>

      <Link to={`/${props.lang}/staff`}>
        <h1 className="text-[22px] md:text-[28px] xl:text-[32px] px-[25px] cursor-pointer">
          {props.lang === "th" ? "บุคลากร" : "Staff"}
        </h1>
        {props.isOpen === 2 && (
          <hr className="rounded-[10px] h-[9px] w-full bg-lightGray" />
        )}
      </Link>

      <Link to={`/${props.lang}/contact-us`}>
        <h1 className="text-[22px] md:text-[28px] xl:text-[32px] px-[25px] cursor-pointer">
          {props.lang === "th" ? "ติดต่อเรา" : "Contact Us"}
        </h1>
        {props.isOpen === 3 && (
          <hr className="rounded-[10px] h-[9px] w-full bg-lightGray" />
        )}
      </Link>
    </div>
  );
}
